import { LocalNotificationsService } from './local-notifications.service';

export default angular
  .module('sfMobile.services.local-notifications', ['sfMobile.services.pubsub'])
  .service('localNotificationsService', LocalNotificationsService).name;
